/**
 * @generated SignedSource<<0524140b6ffbe696b4c3e9f61d856aed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateExpenseItemInput = {
  id?: string | null;
  projectId?: string | null;
  companyProjectId?: number | null;
  name?: string | null;
  billable?: boolean | null;
  partOfFixedPrice?: boolean | null;
  cost?: number | null;
  price?: number | null;
  quantity?: number | null;
  approved?: boolean | null;
  expenseYear?: number | null;
  expenseMonth?: number | null;
  expenseDay?: number | null;
  notes?: string | null;
  planned?: boolean | null;
  personId?: string | null;
  expenseCategoryId?: string | null;
  phaseId?: string | null;
  deliverableId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateExpenseItemMutation$variables = {
  input: UpdateExpenseItemInput;
};
export type updateExpenseItemMutation$data = {
  readonly updateExpenseItem: {
    readonly expenseItem: {
      readonly node: {
        readonly name: string | null;
        readonly approved: boolean | null;
        readonly expenseYear: number | null;
        readonly expenseMonth: number | null;
        readonly expenseDay: number | null;
        readonly billable: boolean | null;
        readonly partOfFixedPrice: boolean | null;
        readonly price: number | null;
        readonly costBaseCurrency: number | null;
        readonly priceBaseCurrency: number | null;
        readonly cost: number | null;
        readonly quantity: number | null;
        readonly planned: boolean | null;
        readonly createdAt: string | null;
        readonly invoiced: boolean | null;
        readonly person: {
          readonly id: string;
          readonly fullName: string | null;
          readonly profilePictureId: string | null;
          readonly profilePictureDefaultId: number | null;
        } | null;
        readonly category: {
          readonly id: string;
        } | null;
        readonly phase: {
          readonly id: string;
        } | null;
        readonly deliverable: {
          readonly id: string;
          readonly name: string | null;
        } | null;
        readonly project: {
          readonly id: string;
          readonly client: {
            readonly id: string;
            readonly name: string;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};
export type updateExpenseItemMutation = {
  variables: updateExpenseItemMutation$variables;
  response: updateExpenseItemMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approved",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expenseYear",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expenseMonth",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expenseDay",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billable",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "partOfFixedPrice",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "costBaseCurrency",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceBaseCurrency",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cost",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quantity",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "planned",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiced",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "person",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profilePictureId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profilePictureDefaultId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v19 = [
  (v17/*: any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "ExpenseCategory",
  "kind": "LinkedField",
  "name": "category",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "PhaseType",
  "kind": "LinkedField",
  "name": "phase",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v22 = [
  (v17/*: any*/),
  (v2/*: any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "DeliverableType",
  "kind": "LinkedField",
  "name": "deliverable",
  "plural": false,
  "selections": (v22/*: any*/),
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectType",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Client",
      "kind": "LinkedField",
      "name": "client",
      "plural": false,
      "selections": (v22/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateExpenseItemMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateExpenseItemPayload",
        "kind": "LinkedField",
        "name": "updateExpenseItem",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ExpenseItemTypeEdge",
            "kind": "LinkedField",
            "name": "expenseItem",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ExpenseItem",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v18/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateExpenseItemMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateExpenseItemPayload",
        "kind": "LinkedField",
        "name": "updateExpenseItem",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ExpenseItemTypeEdge",
            "kind": "LinkedField",
            "name": "expenseItem",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ExpenseItem",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v18/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v17/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9e642a3e736f0756377f8ad917d6804d",
    "id": null,
    "metadata": {},
    "name": "updateExpenseItemMutation",
    "operationKind": "mutation",
    "text": "mutation updateExpenseItemMutation(\n  $input: UpdateExpenseItemInput!\n) {\n  updateExpenseItem(input: $input) {\n    expenseItem {\n      node {\n        name\n        approved\n        expenseYear\n        expenseMonth\n        expenseDay\n        billable\n        partOfFixedPrice\n        price\n        costBaseCurrency\n        priceBaseCurrency\n        cost\n        quantity\n        planned\n        createdAt\n        invoiced\n        person {\n          id\n          fullName\n          profilePictureId\n          profilePictureDefaultId\n        }\n        category {\n          id\n        }\n        phase {\n          id\n        }\n        deliverable {\n          id\n          name\n        }\n        project {\n          id\n          client {\n            id\n            name\n          }\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ae9ca078d8f259d5c429194227a2ac15";

export default node;
